import React from 'react';
import { IconProps } from '.';

const SvgPieChart = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M22.5 10.5a8.997 8.997 0 0 0-9-9v9h9ZM15 3.152A7.5 7.5 0 0 1 20.849 9H15V3.152Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M11.5 2.5v10h10a10.001 10.001 0 1 1-10-10ZM10 14h9.867A8.499 8.499 0 0 1 5.49 18.51 8.5 8.5 0 0 1 10 4.133V14Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgPieChart;
